import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";

import { App } from "./App";
import { store } from "./store";
import { getStrings } from "./utils/APIrequests";
import { updateStrings } from "./utils/strings";

const dist = document.getElementById("addtocartpopup") as HTMLElement;
const root = ReactDOM.createRoot(dist);

getStrings().then((response) => {
	updateStrings(response);
});

const renderApp = (root) =>
	root.render(
		<React.StrictMode>
			<Provider store={store}>
				<App />
			</Provider>
		</React.StrictMode>,
	);

renderApp(root);

document.addEventListener("unmountAddToCartPopup", () => {
	root.unmount();

	const portals = document.querySelectorAll(".ReactModalPortal");
	portals.forEach((portal) => portal.remove());
});

document.addEventListener("remountAddToCartPopup", () => {
	const dist = document.getElementById("addtocartpopup") as HTMLElement;
	dist.innerHTML = "";

	const root = ReactDOM.createRoot(dist);

	renderApp(root);
});
